import { useMemo } from 'react';

export function useContextValue(reducer) {
  const [state, dispatch] = reducer;
  return useMemo(() => ({ state, dispatch }), [state, dispatch]);
}
